import React, { Component } from 'react';
import { images } from '../../../../settings';
import { BrowserRouter as Router, Link } from 'react-router-dom';

import './Distribuicao.scoped.scss';

class Distribuicao extends Component {
  constructor(props) {
    super(props);
    this.images = images;
  }
  render() {
    return (
      <div className="planos-template">
        <div className="planos-template--risca" style={{ backgroundColor: this.props.cor }}></div>
        <div className="planos-template__conteudo">
          {/* <h3 className="h2 h2--500 planos-template__titulo" style={{ color: this.props.cor }}>
            Liquidez
          </h3> */}
          <h4 className="planos-template__subtitulo">
            As iniciativas relacionadas à distribuição de produtos de investimento se deram em duas frentes:
          </h4>
          <div className="planos-template__linha">
            <div className="planos-template__coluna">
              <div className="planos-template__imagem-coluna">
                <img src={this.images.plano_acao_2020.icon_distribuicao1} alt="Ícone" />
              </div>
              <div className="planos-template__conteudo-coluna">
                <h5 className="planos-template__titulo-coluna">Suitability</h5>
                <p>
                  Como parte da revisão geral das regras de suitability, foram discutidas alterações de pontuação mínima
                  de risco dos produtos. Em paralelo, a proposta de revisão da qualificação do investidor foi concluída
                  e teve ajustes solicitados pela Diretoria, principalmente quanto à flexibilização para investimentos
                  realizados por meio do gestor (carteira administrada) e do consultor (contrato de consultoria). Houve
                  um alinhamento preliminar com a CVM e ficou decidido que o tema será tratado ao longo de 2021 em
                  parceria com o regulador, abrangendo não só a qualificação, mas a revisão total da Instrução CVM 539.
                </p>
              </div>
            </div>
          </div>

          <div className="planos-template__linha">
            <div className="planos-template__coluna">
              <div className="planos-template__imagem-coluna">
                <img src={this.images.plano_acao_2020.icon_distribuicao2} alt="Ícone" />
              </div>
              <div className="planos-template__conteudo-coluna">
                <h5 className="planos-template__titulo-coluna">Transparência</h5>
                <p>
                  Foram retomadas as discussões para dar mais transparência na remuneração de agentes de distribuição
                  (terceiros ou emissores). As conversas avançaram, assim como a proposta de padronização na divulgação
                  dos investimentos dos clientes (posições/extrato), que envolveu a avaliação sobre a disponibilidade e
                  a divulgação de preços pela B3 e pela ANBIMA.
                </p>
                <p>
                  Os debates para aprimoramento na prestação de informações sobre riscos foram despriorizados, abrindo
                  espaço para outras discussões de transparência.
                </p>
              </div>
            </div>
          </div>
        </div>
        {/* <div className="planos-template__footer">
          <a
            className="button button--aylen button--green button--border-medium button--size-m button--round-l button--text-thick"
            href="https://www.anbima.com.br/data/files/B5/B5/1F/15/375FE610DC784BE6192BA2A8/Relatorio_de_Iniciativas_2019.pdf "
            target="_blank"
          >
            Saiba mais no Relatório de Iniciativas
          </a>
        </div> */}
      </div>
    );
  }
}
export { Distribuicao };
